import React from 'react';
import {
  Row, Form, Card,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Content } from './styles';

const DataKegiatan = ({ values, inputChange, formik }) => (
  <Content>
    <h3 className="mb-4">Ubah data kuliah umum</h3>
    <Card>
      <Card.Header>Data Kegiatan</Card.Header>
      <Card.Body>

        <Form className="formContainer">
          <Form.Group as={Row} controlId="formPlaintextNamaKegiatan">
            <Form.Label row>
              <p>Nama Kegiatan</p>
            </Form.Label>
            <Form.Control
              type="text"
              id="form1"
              placeholder="Kuliah Umum Ekonomi"
              name="nama_kegiatan"
              onChange={(e) => {
                inputChange(e, 'nama_kegiatan');
                formik.handleChange(e);
              }}
              value={values.nama_kegiatan}
              data-testid="nama_kegiatan"
            />
            {formik.errors.nama_kegiatan && formik.touched.nama_kegiatan && (
            <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.nama_kegiatan}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextJenisKegiatan">
            <Form.Label row>
              <p>Jenis Kegiatan</p>
            </Form.Label>
            <Form.Control
              type="text"
              as="select"
              name="jenis_kegiatan"
              onChange={(e) => {
                inputChange(e, 'jenis_kegiatan');
                formik.handleChange(e);
              }}
              value={values.jenis_kegiatan}
              data-testid="jenis_kegiatan"
            >
              <option value="kuliah umum">kuliah umum</option>
              <option value="seminar ilmiah">seminar ilmiah</option>
            </Form.Control>
            {formik.errors.jenis_kegiatan && formik.touched.jenis_kegiatan && (
            <div className="text-danger">{formik.errors.jenis_kegiatan}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextHariTanggal">
            <Form.Label row>
              <p>Hari/Tanggal</p>
            </Form.Label>
            <Form.Control
              type="date"
              name="tanggal"
              onChange={(e) => {
                inputChange(e, 'tanggal');
                formik.handleChange(e);
              }}
              value={values.tanggal}
              data-testid="tanggal"
            />
            {formik.errors.tanggal && formik.touched.tanggal && (
            <div className="text-danger">{formik.errors.tanggal}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextPukul">
            <Form.Label row>
              <p>Pukul</p>
            </Form.Label>
            <Form.Control
              type="time"
              name="pukul"
              onChange={(e) => {
                inputChange(e, 'pukul');
                formik.handleChange(e);
              }}
              value={values.pukul}
              data-testid="pukul"
            />
            {formik.errors.pukul && formik.touched.pukul && (
            <div className="text-danger">{formik.errors.pukul}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextPenyelenggara">
            <Form.Label row>
              <p>Penyelenggara</p>
            </Form.Label>
            <Form.Control
              type="text"
              name="penyelenggara"
              placeholder="BEM FEB UI"
              onChange={(e) => {
                inputChange(e, 'penyelenggara');
                formik.handleChange(e);
              }}
              value={values.penyelenggara}
              data-testid="penyelenggara"
            />
            {formik.errors.penyelenggara && formik.touched.penyelenggara && (
            <div className="text-danger">{formik.errors.penyelenggara}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextNilaiKUM">
            <Form.Label row>
              <p>Nilai KUM</p>
            </Form.Label>
            <Form.Control
              step="0.1"
              min="0"
              max="9.9"
              type="number"
              name="nilai_kum"
              onChange={(e) => {
                inputChange(e, 'nilai_kum');
                formik.handleChange(e);
              }}
              value={values.nilai_kum}
              data-testid="nilai_kum"
            />
            {formik.errors.nilai_kum && formik.touched.nilai_kum && (
            <div className="text-danger">{formik.errors.nilai_kum}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextBiaya">
            <Form.Label row>
              <p>Biaya</p>
            </Form.Label>
            <Form.Control
              min="0"
              type="number"
              name="biaya"
              onChange={(e) => {
                inputChange(e, 'biaya');
                formik.handleChange(e);
              }}
              value={values.biaya}
              data-testid="biaya"
            />
            {formik.errors.biaya && formik.touched.biaya && (
              <div className="text-danger">{formik.errors.biaya}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextSertifikat">
            <Form.Label row>
              <p>Sertifikat</p>
            </Form.Label>
            <Form.Control
              type="text"
              name="sertifikat"
              placeholder="Ya (Sertifikat Elektronik)"
              onChange={(e) => {
                inputChange(e, 'sertifikat');
                formik.handleChange(e);
              }}
              value={values.sertifikat}
              data-testid="sertifikat"
            />
            {formik.errors.sertifikat && formik.touched.sertifikat && (
            <div className="text-danger">{formik.errors.sertifikat}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextLinkRegistrasi">
            <Form.Label row>
              <p>Link Registrasi</p>
            </Form.Label>
            <Form.Control
              type="text"
              name="link_regis"
              placeholder="s.id/daftarKUM"
              onChange={(e) => {
                inputChange(e, 'link_regis');
                formik.handleChange(e);
              }}
              value={values.link_regis}
              data-testid="link_regis"
            />
            {formik.errors.link_regis && formik.touched.link_regis && (
            <div className="text-danger">{formik.errors.link_regis}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextLokasi">
            <Form.Label row>
              <p>Lokasi</p>
            </Form.Label>
            <Form.Control
              type="text"
              name="lokasi"
              placeholder="Balairung UI"
              onChange={(e) => {
                inputChange(e, 'lokasi');
                formik.handleChange(e);
              }}
              value={values.lokasi}
              data-testid="lokasi"
            />
            {formik.errors.lokasi && formik.touched.lokasi && (
              <div className="text-danger">{formik.errors.lokasi}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlainTextPembicara">
            <Form.Label row>
              <p>Pembicara</p>
            </Form.Label>
            <Form.Control
              type="text"
              name="pembicara"
              placeholder="Fathurizki Luthfi Azzahra"
              onChange={(e) => {
                inputChange(e, 'pembicara');
                formik.handleChange(e);
              }}
              value={values.pembicara}
              data-testid="pembicara"
            />
            {formik.errors.pembicara && formik.touched.pembicara && (
              <div className="text-danger">{formik.errors.pembicara}</div>
            )}
          </Form.Group>

          <Form.Group as={Row} controlId="formPlainTextPembicara">
            <Form.Label row>
              <p>Moderator</p>
            </Form.Label>
            <Form.Control
              type="text"
              name="moderator"
              placeholder="Fathurizki Luthfi Azzahra"
              onChange={(e) => {
                inputChange(e, 'moderator');
                formik.handleChange(e);
              }}
              value={values.moderator}
              data-testid="moderator"
            />
            {formik.errors.moderator && formik.touched.moderator && (
              <div className="text-danger">{formik.errors.moderator}</div>
            )}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  </Content>
);

DataKegiatan.defaultProps = {
  inputChange: () => {},
  values: PropTypes.shape({
    nama_kegiatan: '',
    jenis_kegiatan: '',
    tanggal: '',
    pukul: '',
    penyelenggara: '',
    nilai_kum: '',
    biaya: '',
    sertifikat: '',
    link_regis: '',
    lokasi: '',
    pembicara: '',
    moderator: '',
  }),
};

DataKegiatan.propTypes = {
  values: PropTypes.shape({
    nama_kegiatan: PropTypes.string,
    jenis_kegiatan: PropTypes.string,
    tanggal: PropTypes.string,
    pukul: PropTypes.string,
    penyelenggara: PropTypes.string,
    nilai_kum: PropTypes.string,
    biaya: PropTypes.string,
    sertifikat: PropTypes.string,
    link_regis: PropTypes.string,
    lokasi: PropTypes.string,
    pembicara: PropTypes.string,
    moderator: PropTypes.string,
  }),
  inputChange: PropTypes.func,
  formik: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default DataKegiatan;
